import { render } from "./TrangChu.vue?vue&type=template&id=3a446f5d&scoped=true"
import script from "./TrangChu.vue?vue&type=script&lang=js"
export * from "./TrangChu.vue?vue&type=script&lang=js"

import "./TrangChu.vue?vue&type=style&index=0&id=3a446f5d&lang=scss&scoped=true"
import "./TrangChu.vue?vue&type=style&index=1&id=3a446f5d&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\fe_smartphone-doi-soat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a446f5d"]])

export default __exports__